// /*
//  *   File : confirm-delete.js
//  *   Author : https://evoqins.com
//  *   Description :Delete confirm modal
//  *   Integrations : js-cookie
//  *   Version : 1.0.0
// */

// import React, { memo, useEffect, useState } from 'react'

// // Custom components
// import { PrimaryButton, SecondaryButton } from '../Buttons';
// import { CustomTextArea, CustomTextInput, RadioGroup } from '../FormElements';


// const RADIO_OPTIONS = [
//     { value: 'option1', label: 'Mandatory' },
//     { value: 'option2', label: 'Optional' },
//     { value: 'option3', label: 'Nil' },
// ];

// const EditDetailsModal = (props) => {

//     const [editStatus, setEditStatus] = useState(false);
//     const [name, setName] = useState("");
//     const [nameError, setNameError] = useState("");
//     const [description, setDescription] = useState("");
//     const [descriptionError, setDescriptionError] = useState("");
//     const [selected, setSelected] = useState(null);

//     useEffect(() => {
//         var edit_modal = document.getElementById("confirm-edit-modal");
//         edit_modal.addEventListener("hidden.bs.modal", () => {
//             setEditStatus(false);
//         });
//     }, []);

//     // handle close Modal 
//     const _handleCloseModal = () => {
//         var button = document.getElementById("confirm-edit-modal-close");
//         button.click();
//         setEditStatus(false);
//         props.handleClose();
//     };

//     // handle edit delete 
//     const _handleEditConfirm = (edit_id) => {
//         props.edit(edit_id);
//     };

//     useEffect(() => {
//         setNameError("");
//     }, [name]);

//     useEffect(() => {
//         setDescriptionError("");
//     }, [description]);

//     return (
//         <div className="modal fade" id="confirm-edit-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="confirmDeleteModalLabel" aria-hidden="true">
//             <div className="modal-dialog modal-dialog-centered ">
//                 <div className="modal-content e-border-radius-28 w-400px mx-auto ">
//                     <img src={require("../../Assets/Images/Home/close.svg").default}
//                         draggable={false}
//                         className='d-none'
//                         id='confirm-edit-modal-close'
//                         alt='close'
//                         data-bs-dismiss="modal" />
//                     <div className="modal-header px-4 pt-4 pb-3 border-0 align-items-start justify-content-space-between">


//                         <h4 className='mb-0 e-primary-font e-text-raisin-black e-font-16 e-font-weight-600 line-height-28px'>
//                             Edit Details
//                         </h4>
//                         <img src={require("../../Assets/Images/Home/close.svg").default}
//                             draggable={false}
//                             alt='close'
//                             className='cursor-pointer'
//                             onClick={_handleCloseModal} />
//                         {!editStatus &&

//                             <img src={require("../../Assets/Images/Home/close.svg").default}
//                                 draggable={false}
//                                 className='d-none'
//                                 id='confirm-edit-modal-close'
//                                 alt='close'
//                                 data-bs-dismiss="modal"
//                                 onPress={_handleCloseModal} />
//                         }

//                     </div>
//                     <div className="modal-body px-4 pb-2 pt-0">

//                         <>
//                             <RadioGroup label="Mandatory/Optional"
//                                 labelStyle="e-font-weight-400"
//                                 data={RADIO_OPTIONS}
//                                 selectedItem={selected}
//                                 onSelectItem={(value) => setSelected(value)}
//                             />
//                             <CustomTextInput label="Additional data field number"
//                                 placeholder="Enter Additional data field number"
//                                 type="text"
//                                 // require
//                                 value={name}
//                                 error={nameError}
//                                 autoFocus={true}
//                                 className="w-100"
//                                 labelStyle="e-font-weight-400"
//                                 handleChange={(e) => setName(e)} />

//                             <CustomTextArea label="Additional data description"
//                                 placeholder="Enter Additional data description"
//                                 type="text"
//                                 // require
//                                 value={description}
//                                 error={descriptionError}
//                                 autoFocus={true}
//                                 className="w-100"
//                                 rows={1}
//                                 labelStyle="e-font-weight-400"
//                                 handleChange={(e) => setDescription(e)} />

//                             {/* Custom button  */}
//                             <div className='row row-cols-2 pt-2 mt-2 pb-3'>
//                                 <div className='col'>
//                                     <SecondaryButton name="Cancel"
//                                         className="w-100"
//                                         onPress={_handleCloseModal} />
//                                 </div>
//                                 <div className='col'>
//                                     <PrimaryButton name="Update"
//                                         className="w-100 e-bg-primary-blue"
//                                         onPress={_handleCloseModal}
//                                     />
//                                 </div>
//                             </div>
//                         </>

//                     </div>
//                 </div>
//             </div>
//         </div>

//     )
// }

// EditDetailsModal.defaultProps = {
//     delete: () => { },
//     handleClose: () => { }
// }


// export default memo(EditDetailsModal);



/*
 *   File : edit-details.js
 *   Author : https://evoqins.com
 *   Description :Edit field details modal
 *   Integrations : js-cookie
 *   Version : 1.0.1
*/

import React, { memo, useEffect, useState } from 'react';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { CustomTextArea, CustomTextInput, RadioGroup } from '../FormElements';
import { APIService } from '../../Service';
import { toast } from 'react-toastify';

const RADIO_OPTIONS = [
    { value: 'option1', label: 'Mandatory' },
    { value: 'option2', label: 'Optional' },
    { value: 'option3', label: 'Nil' },
];

const EditDetailsModal = ({ fieldData, handleClose, onUpdate }) => {

    const [editStatus, setEditStatus] = useState(false);
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [description, setDescription] = useState("");
    const [descriptionError, setDescriptionError] = useState("");
    const [selected, setSelected] = useState(null);
    const [fieldNumber, setFieldNumber] = useState("");
    const [fieldNumberError, setFieldNumberError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const edit_modal = document.getElementById("confirm-edit-modal");
        edit_modal.addEventListener("hidden.bs.modal", () => {
            setEditStatus(false);
        });
    }, []);

    useEffect(() => {
        if (fieldData) {
            // setName(fieldData.name || "");
            // setDescription(fieldData.description || "");
            // setFieldNumber(fieldData.data_field_number || "");
            const priority = (fieldData.priority || "").toLowerCase();
            if (priority === "mandatory") setSelected("option1");
            else if (priority === "optional") setSelected("option2");
            else setSelected("option3");
        }
    }, [fieldData]);

    const _handleCloseModal = () => {
        const button = document.getElementById("confirm-edit-modal-close");
        button.click();
        setEditStatus(false);
        handleClose();
    };

    //API- edit
    const _handleUpdate = () => {
        setLoading(true);
        let is_post = true;
        let url = 'field-mapping/edit';
        const data = {
            mapping_id: fieldData.mapping_id,
            // name,
            // description,
            // data_field_number: Number(fieldNumber),
            mandatory: selected === 'option1',
            optional: selected === 'option2',
            nill: selected === 'option3'
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast",
                });
                _handleCloseModal();
                onUpdate();
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoading(false);
        });
    };

    return (
        <div className="modal fade" id="confirm-edit-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content e-border-radius-28 w-400px mx-auto">
                    <img src={require("../../Assets/Images/Home/close.svg").default}
                        draggable={false}
                        className='d-none'
                        id='confirm-edit-modal-close'
                        alt='close'
                        data-bs-dismiss="modal" />
                    <div className="modal-header px-4 pt-4 pb-3 border-0 align-items-start justify-content-space-between">
                        <h4 className='mb-0 e-primary-font e-text-raisin-black e-font-16 e-font-weight-600 line-height-28px'>
                            Edit Details
                        </h4>
                        <img src={require("../../Assets/Images/Home/close.svg").default}
                            draggable={false}
                            alt='close'
                            className='cursor-pointer'
                            onClick={_handleCloseModal} />
                    </div>
                    <div className="modal-body px-4 pb-2 pt-0">
                        {/* <CustomTextInput
                            label="Field name"
                            placeholder="Enter field name"
                            type="text"
                            require
                            value={name}
                            error={nameError}
                            autoFocus={true}
                            className="w-100"
                            labelStyle="e-font-weight-400"
                            handleChange={(e) => setName(e)}
                        /> */}
                        <RadioGroup
                            label="Mandatory/Optional"
                            labelStyle="e-font-weight-400"
                            data={RADIO_OPTIONS}
                            selectedItem={selected}
                            onSelectItem={(value) => setSelected(value)}
                        />
                        {/* <CustomTextInput
                            label="Additional data field number"
                            placeholder="Enter Additional data field number"
                            type="text"
                            value={fieldNumber}
                            error={fieldNumberError}
                            autoFocus={true}
                            className="w-100"
                            labelStyle="e-font-weight-400"
                            handleChange={(e) => setFieldNumber(e)}
                        /> */}
                        {/* <CustomTextArea
                            label="Additional data description"
                            placeholder="Enter Additional data description"
                            type="number"
                            value={description}
                            error={descriptionError}
                            autoFocus={true}
                            className="w-100"
                            rows={1}
                            labelStyle="e-font-weight-400"
                            handleChange={(e) => setDescription(e)}
                        /> */}

                        <div className='row row-cols-2 pt-2 mt-2 pb-3'>
                            <div className='col'>
                                <SecondaryButton name="Cancel"
                                    className="w-100"
                                    onPress={_handleCloseModal} />
                            </div>
                            <div className='col'>
                                <PrimaryButton name="Update" className="w-100 e-bg-primary-blue"
                                    status={loading}
                                    onPress={_handleUpdate} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

EditDetailsModal.defaultProps = {
    fieldData: null,
    handleClose: () => { },
    onUpdate: () => { }
};

export default memo(EditDetailsModal);
